import { PaintStyle } from "../../drawing/PaintStyle";

export interface IPaintableOnEditing {
  paintStyleOnEditing: PaintStyle;
  paintStyle: PaintStyle;
}

export function instanceOfIPaintableOnEditing(instance: any): instance is IPaintableOnEditing {
  return instance
    && (instance.paintStyleOnEditing !== undefined)
    && (instance.paintStyle !== undefined);
}
